const SAITAMA_CITY_ACCESS_KEY = "k8m2v7q4x9n1c6p3w5r0d2fz";
const SAITAMA_CITY_SEASON_ID = "cmuj8rted00010lnwciotguzf";

const SAITAMA_CITY_PROVIDER = {
  label: "さいたま市",
  company: "saitama-city",
  accessKey: SAITAMA_CITY_ACCESS_KEY,
};

export {
  SAITAMA_CITY_ACCESS_KEY,
  SAITAMA_CITY_PROVIDER,
  SAITAMA_CITY_SEASON_ID,
};
